import { Component, OnInit, forwardRef, Inject } from '@angular/core';
import { TranslateService }  from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { CompanyService }    from '../companies/company.service';
import { ConfirmService }    from '../messages/confirm/confirm.service';
import { DvlaLookupService } from './dvla-lookup.service';
import { MessagesService }   from '../messages/messages.service';
import { SessionService }    from '../sessions/session.service';

@Component({
  selector   : 'wor-dvla-lookup-settings',
  template: require('./dvla-lookup.settings.component.html')
})
export class DvlaLookupSettingsComponent implements OnInit {
  hasIntegration: boolean;
  loaded: boolean;
  requests: number;

  constructor (
    @Inject(forwardRef(() => CompanyService))
    private companyService   : CompanyService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService   : ConfirmService,
    @Inject(forwardRef(() => DvlaLookupService)) private dvlaLookupService: DvlaLookupService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    private router           : UIRouter,
    @Inject(forwardRef(() => SessionService))
    private sessionService   : SessionService,
    private translateService  : TranslateService
  ) {}

  ngOnInit (): void {
    this.loaded         = true;
    this.hasIntegration = this.companyService.hasIntegration('dvla-lookup');
    this.requests       = this.sessionService.company().dvla_lookup_requests || 0;
  }

  activate (): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'DVLA Lookup' }))
    .then(() => this.dvlaLookupService.activate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'DVLA Lookup' }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  deactivate (): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'DVLA Lookup' }))
    .then(() => this.dvlaLookupService.deactivate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'DVLA Lookup' }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  purchase (): void {
    this.dvlaLookupService.purchase()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', { name: 'DVLA Lookup' }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }
}
